export default {"src":"/_next/static/media/window-code.2468126f.svg","height":20,"width":20};